export default {
  async loadUsersData  (state) {
    state.commit('setUsersData', await this.$axios.$get('/users'));
  },
  updateProfilePicture (state, data) {
    const usersArray = state.getters.getUsersData;
    const index = usersArray.findIndex(o => o._id === data._id);
    state.commit('setProfilePicture', {i: index, profilePicture: data.profilePicture});
  },
};